import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Skeleton, TextField } from "@mui/material";

import { getEstateCodePrefix, updateEstateCodePrefix } from "../api/financeApi";
import { getApiErrorMessage } from "../utils/concurrency";

export default function EstateCodeSettingsPage() {
  const [prefix, setPrefix] = useState("");
  const [savedPrefix, setSavedPrefix] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getEstateCodePrefix();
        const value = res.data.prefix || "XL";
        setPrefix(value);
        setSavedPrefix(value);
      } catch (e) {
        setError(getApiErrorMessage(e, "Failed to load estate code settings."));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const save = async () => {
    try {
      setSaving(true);
      setError("");
      const res = await updateEstateCodePrefix({ prefix });
      setPrefix(res.data.prefix);
      setSavedPrefix(res.data.prefix);
      setMessage("Estate code prefix saved.");
    } catch (e) {
      setError(getApiErrorMessage(e, "Failed to save estate code prefix."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {loading ? (
        <Skeleton height={56} />
      ) : (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", flexWrap: "wrap" }}>
          <TextField
            label="Estate Code Prefix"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value.toUpperCase())}
            inputProps={{ maxLength: 20 }}
          />
          <Button
            variant="contained"
            onClick={save}
            disabled={saving || prefix === savedPrefix}
          >
            Save
          </Button>
        </Box>
      )}
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      {message && <Alert severity="success" sx={{ mt: 2 }} onClose={() => setMessage("")}>{message}</Alert>}
    </>
  );
}
